import { FaHistory, FaBrain, FaTools, FaArrowRight } from "react-icons/fa";
import { CustomInput } from "reactstrap";
import CustomButton from "../../../../../../shared_components/CustomButton";

const WhySkillsFadeSection = () => {
    const cards = [
        {
            id: 1,
            title: "Learned Long Ago",
            desc: "You completed cards, built projects, and felt confident. But that was months or even years ago. The syntax feels fuzzy now.",
            note: "Skills decay without practice",
            icon: FaHistory,
            bg: "fade-card-red",
        },
        {
            id: 2,
            title: "Memory Gaps",
            desc: "You remember the concepts but struggle with implementation. Flexbox? Grid? Event listeners? It's all a blur.",
            note: "Theory ≠ Practice",
            icon: FaBrain,
            bg: "fade-card-yellow",
        },
        {
            id: 3,
            title: "No Real Practice",
            desc: "Watching tutorials isn't enough. You need to build, break, and fix things yourself to truly master frontend development.",
            note: "Build to learn",
            icon: FaTools,
            bg: "fade-card-purple",
        },
    ];

    return (
        <>
            <section className="row mx-0 justify-content-center my-5 py-5">
                <div className="col-12 col-md-10">
                    <div className="row mx-0 justify-content-center text-center mb-5">
                        <div className="col-12 col-md-10">
                            <span className="text-uppercase small text-custom fw-semibold">
                                The Problem
                            </span>
                            <h1 className="fw-bold mt-2">Why Frontend Skills Fade Away</h1>
                            <p className="mt-2">
                                You spent months learning HTML, CSS, and JavaScript. But without
                                constant practice, those skills rust.
                            </p>
                        </div>
                    </div>

                    <div className="row mx-0 d-flex align-items-center mb-5">
                        {cards.map((item) => (
                            <div className="col-12 col-md-4" key={item.id}>
                                <div className="my-1 h-100 p-4 radius-10 border bg-light">
                                    <div className="mb-3 fs-3 text-custom">
                                        <item.icon size={24} />
                                    </div>
                                    <h5 className="fw-bold mb-2">{item.title}</h5>
                                    <p className="text-muted small mb-3">{item.desc}</p>
                                    <span className="text-custom">{item.note}</span>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="row mx-0 justify-content-center">
                        <div className="col-12">
                            <div className="border radius-10 p-4 p-md-5 text-center">
                                <h3 className="fw-bold mb-2">
                                    The Solution? Deliberate, Hands-On Revision
                                </h3>
                                <p className="mb-4">
                                    We provide structured challenges that force you to recall,
                                    apply, and reinforce your frontend knowledge through real
                                    coding practice.
                                </p>
                                <CustomButton>
                                    See How It Works <FaArrowRight className="ms-2" />
                                </CustomButton>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default WhySkillsFadeSection;
